import React, {useState, useEffect} from 'react';
import useSWR from 'swr';
import {fetchAndQuery, fetchAndQueryItems, fetchAndQueryBlocks} from "./Wquery2"
import {TextCompare} from '../TextCompare/TextCompare'
import FormControl from 'react-bootstrap/FormControl';
import { CATviewNgrams } from '../CATviewNgrams/CATviewNgrams';

export interface MyComponentProps {
  resourceid: string// Define your prop types here
  handleChangeInfo?: (id: string) => void;
  structureType?: string;
  baseText?: string;

}

export const VectorSimilarity: React.FC<MyComponentProps> = (props) => {
  const [filter, setFilter] = useState<string>("");
  const [showCATviewNgrams, setShowCATviewNgrams] = useState<any>({})
  
  
  const { data: results, error: resultsError, isLoading: resultsLoading } = useSWR(
    props.resourceid ? `fetchAndQuery:${props.resourceid}` : null, // SWR key
    () => {
      // TODO; somewhat inaccurately every level below item is given structureType block, even divisions
      // but this conditional aimed to make a distinction between block (paragraphs) and divisions or items
      // but it doesn't work since division are currently labelled as block. 
      // TODO: xTextWrapper should more accurately label the structureType of divisions as divisions rather than as blocks
      // as a short cut, I'm placing a fall back inside the block condition. If no results are found in the block query
      // then it should try the fetchAndQueryItems query which will include divisions (at least for the Aquinas ST text)
      if (props?.structureType === "block") {
        return fetchAndQueryBlocks(props.resourceid) // Pass props.resourceid to fetchAndQueryItems
      }
      else {
        return fetchAndQueryItems(props.resourceid) // Pass props.resourceid to fetchAndQueryItems
      }
    }
  );

  // const [results, setResults] = useState<any[]>([]); // State to store the fetched results
  // const [loading, setLoading] = useState<boolean>(true); // State to track loading
  // const [error, setError] = useState<string | null>(null); // State to track errors

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true); // Start loading
  //     setError(null); // Reset error state
  //     try {
  //       const data = await fetchAndQuery("pgb1q1-arasap"); // Call the async function
  //       setResults(data); // Update results
  //       console.log("data", data)
  //     } catch (err) {
  //       setError("Failed to fetch data."); // Handle errors
  //       console.error(err);
  //     } finally {
  //       setLoading(false); // Stop loading
  //     }
  //   };

  //   fetchData(); // Call the fetch function
  // }, [props.resourceid]); // Empty dependency array ensures this runs once on mount


  return (
    <div>
      {/* <h4>Vector Similarity</h4> */}
      <p>Resource ID: {props.resourceid}</p>
      {/* <input type="text" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter results" /> */}
      <FormControl size="sm" id="text" type="text" placeholder="Filter results" value={filter} onChange={(e) => setFilter(e.target.value)} />
      <>
      {
      results?.length > 0 && (props?.structureType !== "block") && results.map((i: any, idx: number) => {
        const parsedFilter = filter.startsWith("!") ? filter.split("!")[1].toLowerCase() : filter.toLowerCase();
        const negFilter = filter.startsWith("!") ? true : false;
        if (!i.item?.startsWith(props.resourceid.split("-")[0]) && 
        (
          negFilter
            ? (
                !i.authorTitle?.toLowerCase().includes(parsedFilter) &&
                !i.longTitle?.toLowerCase().includes(parsedFilter) &&
                !i.questionTitle?.toLowerCase().includes(parsedFilter)
              )
            : (
                i.authorTitle?.toLowerCase().includes(parsedFilter) ||
                i.longTitle?.toLowerCase().includes(parsedFilter) ||
                i.questionTitle?.toLowerCase().includes(parsedFilter)
              )
        )
      ) {
          return (<div>
            <span className="lbp-span-link" onClick={() => {props?.handleChangeInfo(i.item)}}>{idx}: {i.authorTitle + ", " + i.longTitle} <span>({Math.round((i.certainty * 100))}%)</span></span>
            <br/>
            <span style={{margin: "0px", paddingLeft: "10px", font: "10px"}}>{i.questionTitle}</span>
            <br/>
            <br/>
            {/* {(!showCATviewNgrams || (showCATviewNgrams.source !== props.resourceid || showCATviewNgrams.match !== i.item)) && <span onClick={() => setShowCATviewNgrams({source: props.resourceid, match: i.item})}>viz</span>}
            {(showCATviewNgrams && showCATviewNgrams.source === props.resourceid && showCATviewNgrams.match === i.item) && <span onClick={() => setShowCATviewNgrams({})}>hide viz</span>}
            {(showCATviewNgrams && showCATviewNgrams.source === props.resourceid && showCATviewNgrams.match === i.item) && <CATviewNgrams expressionid={"http://scta.info/resource/" + props.resourceid} expressionConstraint={i.item}/>} */}
            </div>)
          // return <TextCompare 
          // expressionid={i.item} 
          // author={i.author}
          // authorTitle={i.authorTitle}
          // longTitle={i.longTitle}
          // handleChangeInfo={props?.handleChangeInfo}/>
          
        }
        else{
          return null
        }
        
        })
      }
      {
      results?.length > 0 && (props?.structureType === "block" && !props.resourceid.startsWith("TAca84-")) && results.map((i: any, idx: number) => {
        
        // return (<p>{i.pid}</p>)
        return <><span>({Math.round((i.certainty * 100))}%)</span>
        <TextCompare key={"vs-" + i.item} 
        expressionid={i.item} 
        handleChangeInfo={props?.handleChangeInfo} 
        baseText={props.baseText}
        author={i.author}
        authorTitle={i.authorTitle}
        longTitle={i.longTitle}
        />
        </>
        })
      }
      </>
  {/* uncomment to produce string list that can be used in citation table comparison */}
 {/* { 
      results?.length > 0 && props?.structureType !== "block" && results.slice(0,30).map((i: any) => {
        const parsedFilter = filter.startsWith("!") ? filter.split("!")[1].toLowerCase() : filter.toLowerCase();
        const negFilter = filter.startsWith("!") ? true : false;
        if (!i.item?.startsWith(props.resourceid.split("-")[0]) && 
        (
          negFilter
            ? (
                !i.authorTitle?.toLowerCase().includes(parsedFilter) &&
                !i.longTitle?.toLowerCase().includes(parsedFilter) &&
                !i.questionTitle?.toLowerCase().includes(parsedFilter)
              )
            : (
                i.authorTitle?.toLowerCase().includes(parsedFilter) ||
                i.longTitle?.toLowerCase().includes(parsedFilter) ||
                i.questionTitle?.toLowerCase().includes(parsedFilter)
              )
        )
      ) {
          return (i.item + " ")
          
        }
        else{
          return null
        }
        
        })
      } */}


    </div>
    )

}